import React, { useEffect, useState } from 'react';
import { FaSolarPanel, FaBatteryFull, FaHome} from 'react-icons/fa'; // Importing icons
import myImage from './assets/InverterNy.png';  // Import the image
import myTransmissionImage from'./assets/electric-tower.png';
import { GoArrowSwitch } from "react-icons/go";
import myElpatronImage from './assets/Elpatron.png';  // Import the image
import myVarmVattenImage from'./assets/Varmvattenberedare.png';
import myRadiatorImage from './assets/radiator.png';  // Import the image
import BergvarmepumpIcon from "./BergvarmepumpIcon";
import { useSpring, animated } from 'react-spring'; // Importing react-spring
import './Solcell.css'; // Assuming you want to style it via CSS

const SolcellScreen = () => {
  const [data, setData] = useState({});
  const [effectData, setEffectData] = useState({
    orange: 0,
    green: 0,
    red: 0,
    blue: 0,
  });
  const [valueData, setValueData] = useState({
    kompressor: "OFF",
    stopV: 0,
    tillskott6: 0,
    vxl: "RV",
    tillskott3: 0,
    framled: 0,
    vbTemp: 0,
    uteTemp: 0,
    varmV: 0,
    borV: 0,
    inneT: 0,
    uteT:0,
  });

  useEffect(() => {
    const fetchData = () => {
      fetch('/husdata')
        .then(response => response.json())
        .then(json => {
          try {
            setData(json[0]);

            setEffectData({
              orange: json[0]?.Soleffekt || 0,
              green: json[0]?.Batterieffekt || 0,
              red: json[0]?.Huseffekt || 0,
              blue: json[0]?.Näteffekt || 0,
            });

            setValueData({
              kompressor: json[0]?.KompressorStatus || 0,
              stopV: json[0]?.StoppVärde || 0,
              tillskott6: json[0]?.Tillskott6kWStatus || 0,
              vxl: json[0]?.VäxelVentil || 0,
              tillskott3: json[0]?.Tillskott3kWStatus || 0,
              framled: json[0]?.FramLedTemp || 0,
              vbTemp: json[0]?.VBTemp || 0,
              uteT: json[0]?.UteTemp || 0,
              varmV: json[0]?.VarmvattenTemp || 0,
              borV: json[0]?.Börvärde || 0,
              inneT: json[0]?.InneTemp || 0,
            });

          } catch (error) {
            console.error('Failed to parse JSON:', error);
          }
        })
        .catch(error => console.error('Fetch error:', error));
    };

    fetchData();
    const intervalId = setInterval(fetchData, 6000);
    return () => clearInterval(intervalId);
  }, []);

  const getDirection = (effect) => {
    if (effect > 0) {
      return 1000; // Positive effect: animate in one direction
    } else if (effect < 0) {
      return -1000; // Negative effect: animate in the opposite direction
    }
    return 0; // No effect: stop animation
  };

  const getOrangeMove = (value,value1) => {
    console.log('data',value,value1);
    if (value === "VV" && value1 ==="ON") {
      return -1000; // Positive effect: animate in one direction
    } 
    return 0; // No effect: stop animation
  };

  const getGreenMove = (value,value1) => {
    if (value === "RV" && value1 === "ON") {
      return -1000; // Positive effect: animate in one direction
    } 
    return 0; // No effect: stop animation
  };

  const getRedMove = (value,value1) => {
    if (value === "ON" && value1 === "ON") {
      return 1000; // Positive effect: animate in one direction
    } 
    return 0; // No effect: stop animation
  };

  const getBlueMove = (value,value1) => {
    if (value === "ON" && value1 === "ON") {
      return 1000; // Positive effect: animate in one direction
    } 
    return 0; // No effect: stop animation
  };

  const getBlueMoveKompressor = (value,value1,value2) => {
    console.log('data',value,value1,value2);
    if (value ==="OFF" && value1 === "OFF" && value2 === "ON") {
      return 1000; // Positive effect: animate in one direction
    } 
    return 0; // No effect: stop animation
  };

  // Define the spring animations for each line
  const orangeLineSpring = useSpring({
    strokeDashoffset: getDirection(effectData.orange),
    config: { duration: 65000 },
    reset: true,
    from: { strokeDashoffset: 0 },
    to: { strokeDashoffset: getDirection(effectData.orange) },
  });

  const greenLineSpring = useSpring({
    strokeDashoffset: getDirection(effectData.green),
    config: { duration: 65000 },
    reset: true,
    from: { strokeDashoffset: 0 },
    to: { strokeDashoffset: getDirection(effectData.green) },
  });

  const redLineSpring = useSpring({
    strokeDashoffset: getDirection(effectData.red),
    config: { duration: 65000 },
    reset: true,
    from: { strokeDashoffset: 0 },
    to: { strokeDashoffset: getDirection(effectData.red) },
  });

  const blueLineSpring = useSpring({
    strokeDashoffset: getDirection(effectData.blue),
    config: { duration: 65000 },
    reset: true,
    from: { strokeDashoffset: 0 },
    to: { strokeDashoffset: getDirection(effectData.blue) },
  });

  const orangeVarmeLineSpring = useSpring({
    strokeDashoffset: getOrangeMove(valueData.vxl,valueData.kompressor),
    config: { duration: 65000 },
    reset: true,
    from: { strokeDashoffset: 0 },
    to: { strokeDashoffset: getOrangeMove(valueData.vxl,valueData.kompressor) },
  });

  const orangeVarmePathSpring = useSpring({
    strokeDashoffset: getOrangeMove(valueData.vxl,valueData.kompressor),
    config: { duration: 65000 },
    reset: true,
    from: { strokeDashoffset: 0 },
    to: { strokeDashoffset: getOrangeMove(valueData.vxl,valueData.kompressor) },
  });

  const greenVarmeLineSpring = useSpring({
    strokeDashoffset: getGreenMove(valueData.vxl,valueData.kompressor),
    config: { duration: 65000 },
    reset: true,
    from: { strokeDashoffset: 0 },
    to: { strokeDashoffset: getGreenMove(valueData.vxl,valueData.kompressor) },
  });

  const greenVarmePathSpring = useSpring({
    strokeDashoffset: getGreenMove(valueData.vxl,valueData.kompressor),
    config: { duration: 65000 },
    reset: true,
    from: { strokeDashoffset: 0 },
    to: { strokeDashoffset: getGreenMove(valueData.vxl,valueData.kompressor) },
  });

  const redVarmeLineSpring = useSpring({
    strokeDashoffset: getRedMove(valueData.tillskott6,valueData.kompressor),
    config: { duration: 65000 },
    reset: true,
    from: { strokeDashoffset: 0 },
    to: { strokeDashoffset: getRedMove(valueData.tillskott6,valueData.kompressor) },
  });

  const redVarmeLineSpring1 = useSpring({
    strokeDashoffset: getRedMove(valueData.tillskott3,valueData.kompressor),
    config: { duration: 65000 },
    reset: true,
    from: { strokeDashoffset: 0 },
    to: { strokeDashoffset: getRedMove(valueData.tillskott3,valueData.kompressor) },
  });

  const blueVarmeLineSpring = useSpring({
    strokeDashoffset: getBlueMove(valueData.tillskott3,valueData.kompressor),
    config: { duration: 65000 },
    reset: true,
    from: { strokeDashoffset: 0 },
    to: { strokeDashoffset: getBlueMove(valueData.tillskott3,valueData.kompressor) },
  });

  const blueVarmeLineSpring1 = useSpring({
    strokeDashoffset: getBlueMoveKompressor(valueData.tillskott3,valueData.tillskott6,valueData.kompressor),
    config: { duration: 65000 },
    reset: true,
    from: { strokeDashoffset: 0 },
    to: { strokeDashoffset: getBlueMoveKompressor(valueData.tillskott3,valueData.tillskott6,valueData.kompressor) },
  });

  const blueVarmeLineSpring2 = useSpring({
    strokeDashoffset: getBlueMove(valueData.tillskott6,valueData.kompressor),
    config: { duration: 65000 },
    reset: true,
    from: { strokeDashoffset: 0 },
    to: { strokeDashoffset: getBlueMove(valueData.tillskott6,valueData.kompressor) },
  });

  return (
    <div>
      <h1>Hussystem</h1>
    <div className="fullContainer">
      <div className="gridSolContainer">
        {/* Animated SVG Lines */}
        <svg className="svgContainer">
          <animated.line
            x1="45%" y1="40%" x2="25%" y2="10%"
            stroke="orange"
            strokeWidth="5"
            strokeDasharray="5,5"
            strokeDashoffset={orangeLineSpring.strokeDashoffset}
          />
          <animated.line
            x1="70%" y1="20%" x2="55%" y2="40%"
            stroke="green"
            strokeWidth="5"
            strokeDasharray="5,5"
            strokeDashoffset={greenLineSpring.strokeDashoffset}
          />
          <animated.line
            x1="72%" y1="70%" x2="55%" y2="50%"
            stroke="red"
            strokeWidth="5"
            strokeDasharray="5,5"
            strokeDashoffset={redLineSpring.strokeDashoffset}
          />
          <animated.line
            x1="23%" y1="75%" x2="45%" y2="50%"
            stroke="blue"
            strokeWidth="5"
            strokeDasharray="5,5"
            strokeDashoffset={blueLineSpring.strokeDashoffset}
          />
        </svg>
        <div className="inverterContainer">
          <img 
            src={myImage} 
            alt="Inverter" 
            className="imageContainer" 
          />
          <p className="inverterText">{data?.SolSystemStatus || 'N/A'}</p>
          <p className="inverterLabel">Inverter</p>
        </div>
          {/* Solar Section */}
        <div className="solContainer solar">
          <FaSolarPanel size={40} color="black" />
          <p className="boxNum">{data?.Soleffekt || 0} W</p>
          <p className="boxText">Sol effekt</p>
        </div>

          {/* Battery Section */}
        <div className="batteryContainer battery">
        <p className="boxNum">{data?.Batteriladd || 0} %</p>
          <FaBatteryFull size={70} color="black" />          
          <p className="boxNum">{data?.Batterieffekt || 0} W</p>
          <p className="boxtText">Batteri</p>
        </div>

          {/* Feed In Section */}
        <div className="feedInContainer feedIn">
          <img 
            src={myTransmissionImage} 
            alt="Transmission Tower"
            width={40}
            height={40}
          />
          <p className="boxNum">{Math.abs(data?.Näteffekt) || 0} W</p>
          <p className="boxText">Nät effekt</p>
        </div>

          {/* Load Section */}
        <div className="loadContainer load">
          <FaHome size={40} color="black" className="fa-home"   />
          <p className="boxNum">{data?.Huseffekt || 0} W</p>
          <p className="boxText">Hus effekt</p>
        </div>
      </div>
      <div className="gridVarmeContainer">
        {/* Animated SVG Lines */}
        <svg  className="svgContainer">
        <animated.line
          x1="50%" y1="30%" x2="20%" y2="10%"
          stroke="orange"
          strokeWidth="5"
          strokeDasharray="5,5"
          strokeDashoffset={orangeVarmeLineSpring.strokeDashoffset}
        />
        <animated.line
          x1="50%" y1="24%" x2="70%" y2="10%"
          stroke="green"
          strokeWidth="5"
          strokeDasharray="5,5"
          strokeDashoffset={greenVarmeLineSpring.strokeDashoffset}
        />
        <animated.line
          x1="45%" y1="28%" x2="65%" y2="35%"
          stroke="red"
          strokeWidth="5"
          strokeDasharray="5,5"
          strokeDashoffset={redVarmeLineSpring.strokeDashoffset}
        />
        <animated.line
          x1="40%" y1="30%" x2="25%" y2="35%"
          stroke="red"
          strokeWidth="5"
          strokeDasharray="5,5"
          strokeDashoffset={redVarmeLineSpring1.strokeDashoffset}
        />

        <animated.line
          x1="25%" y1="50%" x2="50%" y2="75%"
          stroke="blue"
          strokeWidth="5"
          strokeDasharray="5,5"
          strokeDashoffset={blueVarmeLineSpring.strokeDashoffset}
        />
        <animated.line
          x1="45%" y1="30%" x2="45%" y2="70%"
          stroke="blue"
          strokeWidth="5"
          strokeDasharray="5,5"
          strokeDashoffset={blueVarmeLineSpring1.strokeDashoffset}
        />
        <animated.line
          x1="70%" y1="45%" x2="40%" y2="75%"
          stroke="blue"
          strokeWidth="5"
          strokeDasharray="5,5"
          strokeDashoffset={blueVarmeLineSpring2.strokeDashoffset}
        />

      </svg>
      <svg  className="svgPathContainer">
      <animated.path
          d="M790 170 L790 665 500 665"
          stroke="green"
          strokeWidth="5"
          strokeDasharray="5,5"
          fill="none"
          strokeDashoffset={greenVarmePathSpring.strokeDashoffset}
        />
        <animated.path 
         d="M110 170 L110 665 350 665"
         fill="none" 
         stroke="orange" 
         strokeWidth="5"  
         strokeDasharray="5,5" 
         strokeDashoffset={orangeVarmePathSpring.strokeDashoffset}
        />
      </svg>
      <div className="kompressorContainer kompressor">
        <p className="boxText">VB temp.</p>
        <p className="boxNum">{data?.VBTemp || 'N/A'} C</p>
        <BergvarmepumpIcon/>
        <p className="boxNum">{data?.KompressorStatus || 'N/A'}</p>
      </div>
      <div className="waterContainer water">
        <img 
          src={myVarmVattenImage} 
          alt="Varmvattenberedare" 
          width={50}
          height={50}
        /> 
        <p className="boxNum">{data?.VarmvattenTemp || 'N/A'} C</p>
      </div>
      <div className="radiatorContainer radiator">
        <img 
            src={myRadiatorImage} 
            alt="Varmvattenberedare" 
            width={50}
            height={50}
        /> 
        <p className="boxNum">{data?.FramledTemp || 'N/A'} C</p>
      </div>
      <div className="box borVarde">
        <p className="boxText">Börvärde</p>
        <p className="boxNum">{data.Börvärde || 'N/A'} C</p>
        <p className="boxText">Startvärde</p>
        <p className="boxNum">{data?.Startvärde || 'N/A'} C</p>
        <p className="boxText">Stoppvärde</p>
        <p className="boxNum">{data?.Stoppvärde || 'N/A'} C</p>
      </div>
      <div className="tillskottContainer tillSkott3kW">
        <img src={myElpatronImage}
          alt="Elpatron"
          width={50}
          height={50}/> 
        <p className="boxText">3kW</p>
        <p className="boxNum">{data?.Tillskott3kWStatus || 'N/A'}</p>
      </div>
      <div className="tillskottContainer tillSkott6kW">
        <img src={myElpatronImage}
          alt="Elpatron"
          width={50}
          height={50}/>
        <p className="boxText">6kW</p>
        <p className="boxNum">{data?.Tillskott6kWStatus || 'N/A'}</p>
      </div>
      <div className="houseContainer house">
        <p className="boxText">Ute</p>
        <p className="boxNum">{data?.Utetemp || 'N/A'} C</p>
        <FaHome size={60} color="black" className="fa-home" />
        <p className="boxText">Inne</p>
        <p className="boxNum">{data?.InneTemp || 'N/A'} C</p>
      </div>
      <div className="vxlContainer vxlVentil">
        <GoArrowSwitch  size={40} color='black'className="go-vxl"/>
        <p className="boxNum">{data?.VäxelVentil || 'N/A'}</p>
      </div>
    </div>
    </div>
    </div>
  );
};

export default SolcellScreen;